import { CollectionService } from './index';
import axiosClient from '../http/axios-client';

const ThematicPackageService = CollectionService('thematicpackages');

ThematicPackageService.proceed = (id, data) => {
  return axiosClient.put(`thematicpackages/${ id }/proceed`, data);
};

export default ThematicPackageService;
